import { render } from "./TemplatesPanel.vue?vue&type=template&id=3e0a9cc7&scoped=true"
import script from "./TemplatesPanel.vue?vue&type=script&lang=js"
export * from "./TemplatesPanel.vue?vue&type=script&lang=js"

import "./TemplatesPanel.vue?vue&type=style&index=0&id=3e0a9cc7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e0a9cc7"]])

export default __exports__